<script>
    export let title = "Niekde nastala chyba, skúste to prosím znovu."
    export let text = null
</script>

<div class="error-content">
    <img alt="Error" class="img-fluid" src="/assets/img/error-sleeping.webp">
    <h3>{title}</h3>
    {#if text}
        <p class="text">{@html text}</p>
    {/if}
</div>



<style>
    .text {
        margin-top: 1rem;
        margin-bottom: 3rem;
        margin-inline: 2rem;
    }
</style>